import React from 'react';
import Typography from '@material-ui/core/Typography';
import { Tooltip } from '@material-ui/core';
import {
  TimelineConnector,
  TimelineContent,
  TimelineDot,
  TimelineItem,
  TimelineOppositeContent,
  TimelineSeparator
} from '@material-ui/lab';
import { useAuditTrailsStyles } from './style';
import { getIcon } from '../../utils/auditTrailIcons';

/**
 * EventItem component for displaying individual audit trail events
 * @param {Object} props - Component props
 * @param {Object} props.e - Event object containing operation details
 * @param {boolean} props.last - Whether this is the last item in the timeline
 */
const EventItem = (props) => {
  const { e, last } = props
  const classes = useAuditTrailsStyles()

  const legend = getIcon({
    operation: e?.operation,
    formName: e?.formName,
    formType: e?.formType
  })

  return (
    <TimelineItem>
      <TimelineOppositeContent className={classes.opposite}>
        {new Date(e.createdDate?.trim()).toLocaleString()}
      </TimelineOppositeContent>
      <TimelineSeparator className={classes.separator}>
        <TimelineDot
          className={classes.dot}
          style={{ backgroundColor: legend?.bgColor }}
        >
          {legend?.icon}
        </TimelineDot>
        {!last && <TimelineConnector className={classes.connector} />}
      </TimelineSeparator>
      <TimelineContent className={classes.content}>
        <Tooltip title={e.message}>
          <Typography className={classes.title}>{e.message}</Typography>
        </Tooltip>
        <Typography className={classes.subtitle}>By {e.userName}</Typography>
      </TimelineContent>
    </TimelineItem>
  )
}

export default EventItem;
